<template>
  <el-row class="container_self">
    <el-row class="table_parent">
      <el-row class="add_btn"
        ><el-button type="primary" icon="el-icon-plus" size="mini" @click="createUser"
          >新增策略</el-button
        ></el-row
      >

      <el-row class="search_parent">
        <!-- <el-row>搜索</el-row> -->
        <el-input
          v-model="searchName"
          clearable
          placeholder="请输入packageName"
          size="mini"
        ></el-input>
        <el-button type="warning" icon="el-icon-search" @click="search" size="mini"
          >搜索</el-button
        >
      </el-row>
      <el-row>
        <h3 style="width: 100%">策略列表</h3>
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 10px"
          v-loading="loading"
          element-loading-text="加载中，请稍后"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="50"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            prop="channelTypes"
            label="channelTypes"
            align="center"
          ></el-table-column>
          <el-table-column
            label="所属客户"
            align="center"
            prop="customerName"
          ></el-table-column>
          <el-table-column
            label="应用包名"
            align="center"
            prop="packageName"
          ></el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.disabled ? "禁用" : "可用" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="strategy"
            label="strategy"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="editAd(scope.row)"
                >更新</el-button
              >
              <el-button type="danger" size="mini" @click="deletetAd(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>

    <el-dialog
      :title="string + '策略'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form
        :model="form"
        label-width="125px"
        :rules="rules"
        ref="ruleForm"
        size="mini"
        class="demo-ruleForm form-column"
      >
        <el-form-item label="所属客户">
          <el-select
            v-model="customId"
            remote
            reserve-keyword
            filterable
            placeholder="请输入关键词"
            :remote-method="searchPackage"
            @change="choseCustom"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <!-- <el-input type="text" v-model="form.packageName"></el-input> -->
        </el-form-item>
        <el-form-item label="APP 包名">
          <el-select
            v-model="form.packageName"
            remote
            reserve-keyword
            filterable
            placeholder="请输入关键词"
          >
            <el-option
              v-for="item in packages"
              :key="item.packageName"
              :label="item.packageName"
              :value="item.packageName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="策略优先级">
          <el-select v-model="form.strategy" @change="typeChange">
            <el-option label="优先" :value="0" key="type1"></el-option>
            <el-option label="强制" :value="1" key="type2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="策略顺序" prop="channelTypes" v-if="form.strategy == 1">
          <el-select v-model="form.channelTypes" multiple>
            <el-option
              v-for="(item, index) in channelTypes"
              :label="item.channelType"
              :value="item.channelType"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="策略顺序" prop="channelTypes" v-else>
          <el-select v-model="form.channelTypes" multiple>
            <el-option
              v-for="(item, index) in channelTypes"
              :label="item.channelType"
              :value="item.channelType"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="超时重新获取" style="width: 44% !important">
          <el-input v-model="form.expire" type="number" placeholder="单位：秒"></el-input>
        </el-form-item>
        <el-form-item label="是否禁用">
          <el-switch v-model="form.disabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
export default {
  data() {
    return {
      customId: "",
      isMultipleSelect: true,
      total: 0,
      searchName: "",
      pageSize: 50,
      tableData: [],
      loading: false,
      currentPage: 1,
      dialogFormVisible: false,
      form: {
        channelTypes: [],
        disabled: false,
        packageName: "",
        strategy: 0,
        expire: 0,
      },
      rules: {
        // name: [
        //     { required: true, message: '请输入客户名称', trigger: 'blur' },
        //     { min: 1, max: 25, message: '长度在 1 到 25 个字符', trigger: 'blur' }
        // ],
        // email: [
        //     { required: true, message: '请输入email作为登录账号', trigger: 'blur' }
        // ],
        // password:[
        //     { required: true, message: '请输入登录密码', trigger: 'blur' }
        // ],
        // roles:[
        //     { required: true, message: '请选择角色', trigger: 'blur' }
        // ]
      },
      edit: false,
      id: "",
      roles: [],
      edit: false,
      string: "新增",
      options: [], //customs
      packages: [],
      channelTypes: [],
    };
  },
  methods: {
    choseCustom(val) {
      if (val) {
        axiosGet("/api/app_web/list?customerId=" + val).then((res) => {
          console.log(res);
          if (res.code == 0) {
            let result = res.data.records;
            this.packages = result;
          }
        });
      }
    },
    typeChange(val) {
      if (val == 1) {
        this.form.channelTypes = "";
      } else {
        this.form.channelTypes = [];
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getAdList({
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.searchName,
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAdList({
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.searchName,
      });
    },
    search() {
      this.currentPage = 1;
      this.pageSize = 50;
      this.getAdList({ currentPage: 1, pageSize: 50, packageName: this.searchName });
    },
    createUser() {
      this.dialogFormVisible = true;
    },
    editAd(item) {
      this.edit = true;
      this.string = "更新";
      let obj = JSON.parse(JSON.stringify(item));
      let channelTypes = JSON.parse(JSON.stringify(item.channelTypes));
      obj.channelTypes = channelTypes;
      if (obj.strategy == 1) {
        obj.channelTypes = channelTypes;
      } else {
        obj.channelTypes = channelTypes.split(",");
        // this.isMultipleSelect=true;
      }
      this.searchPackage(item.customerName);
      this.customId = item.customerId;
      this.choseCustom(item.customerId);
      obj.disabled = obj.disabled ? true : false;
      this.form = obj;
      this.id = item.id;
      this.dialogFormVisible = true;
    },
    deletetAd(item) {
      this.$confirm(`确定要删除ID为 ${item.id} 的这条策略吗？`, "警告", {
        confirmButtonText: "确定",
        closeOnClickModal: false,
        cancelButtonText: "取消",
        type: "warning",
        callback: (action) => {
          axiosPost("/api/ads/delete_strategy", { id: item.id }, "JSON").then((res) => {
            if (res.code == 0) {
              this.$message({ message: `策略删除成功`, type: "success" });
              this.getAdList({ currentPage: 1, pageSize: 50, keyword: this.searchName });
            }
          });
        },
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let addAdRequest = {
            channelTypes: Array.isArray(this.form.channelTypes)
              ? this.form.channelTypes.join(",")
              : this.form.channelTypes,
            disabled: this.form.disabled ? 1 : 0,
            packageName: this.form.packageName || "",
            strategy: this.form.strategy || "0",
            expire: this.form.expire || 0,
          };
          let url = "";
          if (!this.edit) {
            url = "/api/ads/add_strategy";
            this.string = "添加";
          } else {
            url = "/api/ads/update_strategy";
            this.string = "更新";
            addAdRequest.id = this.id;
          }
          axiosPost(url, addAdRequest, "JSON").then((res) => {
            if (res.code == 0) {
              this.$message({ message: `${this.string}成功`, type: "success" });
              this.getAdList({ currentPage: 1, pageSize: 50 });
              this.dialogFormVisible = false;
              this.edit = false;
              this.id = "";
              this.resetForm("ruleForm");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
      let _this = this;
      this.customId = "";
      this.options = [];
      this.packages = [];
      setTimeout(function () {
        //此定时器是为了防止页面UI抖动，可移除
        _this.showclient = true;
        _this.edit = false;
        // _this.isMultipleSelect=true;
        _this.form = {
          channelTypes: [],
          disabled: false,
          packageName: "",
          strategy: 0,
        };
      }, 500);
    },
    searchPackage(keyword) {
      if (keyword) {
        this.getCustomList({ currentPage: 1, pageSize: 20, keyword: keyword });
      }
    },
    async getCustomList(params) {
      await axiosGet(
        "/api/customer/list?currentPage=" +
          params.currentPage +
          "&pageSize=" +
          params.pageSize +
          "&keyword=" +
          params.keyword
      ).then((res) => {
        if (res.code == 0) {
          this.options = res.data.records;
        }
      });
    },
    async getAdList(params) {
      this.loading = true;
      let res = await axiosGet("/api/ads/strategy_list", params);
      this.loading = false;
      if (res.code == 0) {
        this.tableData = res.data.records;
        this.total = res.data.total;
      }
    },
  },
  mounted() {
    this.getAdList({ currentPage: 1, pageSize: 50, keyword: this.searchName });
    //  	/api/gam/account/types
    axiosGet("/api/ads/channel/list").then((res) => {
      if (res.code == 0) {
        this.channelTypes = res.data;
      }
    });
  },
};
</script>
<style scoped>
.add {
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  background-color: #2698f1;
  color: #fff;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/view/AdManager/strategyListList.vue